"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerspectiveCameraControls = void 0;
const AbstractCameraControls_1 = require("./AbstractCameraControls");
const CameraControlsEventDistribution_1 = require("./CameraControlsEventDistribution");
const CameraControlsLogic_1 = require("./CameraControlsLogic");
class PerspectiveCameraControls extends AbstractCameraControls_1.AbstractCameraControls {
    // #endregion Properties (3)
    // #region Constructors (1)
    constructor(camera, enabled) {
        super(camera, enabled);
        // #region Properties (3)
        this._settingsAdjustments = {
            autoRotationSpeed: (2 * Math.PI) / 60 / 60,
            damping: 1.0,
            movementSmoothness: 1.0,
            panSpeed: 1.75,
            rotationSpeed: Math.PI,
            zoomSpeed: 0.025,
        };
        this._touchAdjustments = {
            autoRotationSpeed: 1.0,
            damping: 1.0,
            movementSmoothness: 1.0,
            panSpeed: 1.0 / 1.75,
            rotationSpeed: 1.5,
            zoomSpeed: 100.0,
        };
        this._cameraLogic = new CameraControlsLogic_1.CameraControlsLogic(this, this._settingsAdjustments, this._touchAdjustments);
        this._cameraControlsEventDistribution =
            new CameraControlsEventDistribution_1.CameraControlsEventDistribution(this, this._cameraLogic);
    }
}
exports.PerspectiveCameraControls = PerspectiveCameraControls;
//# sourceMappingURL=PerspectiveCameraControls.js.map